module.exports = __webpack_public_path__ + "static/media/cancel.5d584b06.svg";